import React, { useLayoutEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import './App.css';
import { ZoomTransitionProvider, useZoomTransition, SCROLL_KEY, endTransition } from './ZoomTransition';
import HeroHeader from './components/HeroHeader';
import TabBar from './components/TabBar';
import Footer from './components/Footer';
import DetailPageMacOSReality from './components/DetailPageMacOSReality';
import DetailPageMicrosoft from './components/DetailPageMicrosoft';
import DetailPageVisionProAppStore from './components/DetailPageVisionProAppStore';
import DetailPageMetaAvatars from './components/DetailPageMetaAvatars';
import DetailPageAppStoreWeb from './components/DetailPageAppStoreWeb';
import DetailPageAppleGames from './components/DetailPageAppleGames';
import DetailPageAppleIntelligenceReview from './components/DetailPageAppleIntelligenceReview';

const Home = () => {
  const { offset } = useZoomTransition();
  const contentRef = useRef(null);

  // Come back to where the grid was left off, before the enter animation paints.
  useLayoutEffect(() => {
    const stored = sessionStorage.getItem(SCROLL_KEY);
    if (stored !== null) {
      window.scrollTo(0, parseInt(stored, 10));
      sessionStorage.removeItem(SCROLL_KEY);
    }
  }, []);

  return (
    <motion.div
      ref={contentRef}
      className="page"
      initial={{ opacity: 0, y: 200, scale: 1.3, filter: 'blur(10px)' }}
      animate={{ opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' }}
      exit={{
        opacity: 0,
        x: offset.x,
        y: -offset.y,
        scale: 1.75,
        filter: 'blur(8px)',
      }}
      style={{
        transformOrigin: offset.x !== 0
          ? `${offset.x > 0 ? '25%' : '75%'} center`
          : '50% center',
      }}
      transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
      onAnimationComplete={() => {
        // Drop the finished filter so it doesn't leave a rasterized layer behind.
        if (contentRef.current) contentRef.current.style.filter = '';
        endTransition();
      }}
    >
      <div className="page-content">
        <HeroHeader />
      </div>
      <TabBar />
      <div className="page-content">
        <Footer />
      </div>
    </motion.div>
  );
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/detail/macos-reality" element={<DetailPageMacOSReality />} />
        <Route path="/detail/microsoft" element={<DetailPageMicrosoft />} />
        <Route path="/detail/vision-pro-app-store" element={<DetailPageVisionProAppStore />} />
        <Route path="/detail/meta-avatars" element={<DetailPageMetaAvatars />} />
        <Route path="/detail/app-store-web" element={<DetailPageAppStoreWeb />} />
        <Route path="/detail/apple-games" element={<DetailPageAppleGames />} />
        <Route path="/detail/apple-intelligence-review-summarization" element={<DetailPageAppleIntelligenceReview />} />
        <Route path="/detail/:id" element={<DetailPageMacOSReality />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ZoomTransitionProvider>
        <AnimatedRoutes />
      </ZoomTransitionProvider>
    </BrowserRouter>
  );
}

export default App;
